var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-selector-tool",
    clipPath: "url(#clip0_45_1382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0886 13.7577L8.68567 8.58729L8.32441 7.80996L7.82561 8.50707L5.73947 11.4226V1.02873L13.8899 7.43264H10.2154H9.43076L9.7622 8.14384L12.1475 13.2622L11.0886 13.7577Z",
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.64198 15.0479L6.85325 15.5025L7.3073 15.2901L9.17877 14.4144L9.63095 14.2028L9.42007 13.7503L7.27911 9.15618H11.3706H12.8163L11.6795 8.26302L2.06462 0.708464L1.25571 0.0728916V1.10162V13.4636V15.0217L2.16234 13.7546L4.51367 10.4684L6.64198 15.0479Z",
    fill: "#626262",
    stroke: "#ECF5F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_1382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSelect);
export default __webpack_public_path__ + "static/media/multi-select.456a3d6b734336085777c106a53aa885.svg";
export { ForwardRef as ReactComponent };